import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {AppLocalStorage} from "app/app-storage-manager/local-storage";
import {MiscService} from "app/shared/misc.service";
import {environment} from "environments/environment";
import {retry} from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class JobService {
    private readonly REPORT_BASE_URL = `${environment.BASE_URL}/cmp-report/v2`;
    private readonly AUTH_BASE_URL = `${environment.BASE_URL}/cmp-auth/v2`;
    constructor(private http: HttpClient, private miscService: MiscService, private appLocalStorage: AppLocalStorage) {}

    fetchJobs = (
        page: any = "",
        pageSize: any = 0,
        approved?: boolean,
        search?: string,
        jobType?: string,
        employmentType?: string,
        jobId?: string
    ) => {
        let params = new HttpParams();
        if (page) {
            params = params.append("page", page);
        }
        if (pageSize) {
            params = params.append("pageSize", pageSize);
        }
        if (search) {
            params = params.append("search", search);
        }
        if (approved !== null && approved !== undefined) {
            params = params.append("approved", approved);
        }

        if (jobType) {
            params = params.append("jobType", jobType);
        }
        if (employmentType) {
            params = params.append("employmentType", employmentType);
        }
        if (jobId) {
            params = params.append("jobId", jobId);
        }

        const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
        .set("Content-Type", "application/json");

        return this.http.get(`${this.REPORT_BASE_URL}/job/getJobs`, {headers, params}).pipe(retry(2));
    };

    fetchEmploymentType = (page = "", pageSize = "") => {
        let params = new HttpParams();
        if (page) {
            params = params.append("page", page);
        }
        if (pageSize) {
            params = params.append("pageSize", pageSize);
        }
        return this.http
        .get(`${this.REPORT_BASE_URL}/job/list-employmentType`, {
            params,
        })
        .pipe(retry(2));
    };
    createJob = (payload) => this.http.post(`${this.AUTH_BASE_URL}/job/createJob`, payload);

    updateJob = (payload, jobId) => this.http.post(`${this.AUTH_BASE_URL}/job/updateJob/${jobId}`, payload);

    changeJobStatus = (jobId, approved) => {
        let params = new HttpParams();
        if (jobId) {
            params = params.append("jobId", jobId);
        }
        if (approved) {
            params = params.append("approved", approved);
        }
        return this.http
        .put(`${this.AUTH_BASE_URL}/job/approveJob?jobId=${jobId}&approved=${approved}`, {})
        .pipe(retry(2));
    };

    approveJobApplication = (payload) => {
        return this.http.post(`${this.AUTH_BASE_URL}/job/approveJobApplication`, payload);
    };

    fetchJobType = (page = "", pageSize = "") => {
        let params = new HttpParams();
        if (page) {
            params = params.append("page", page);
        }
        if (pageSize) {
            params = params.append("pageSize", pageSize);
        }
        return this.http
        .get(`${this.REPORT_BASE_URL}/job/list-jobTypes`, {
            params,
        })
        .pipe(retry(2));
    };

    fetchCompanyType = (page = "", pageSize = "") => {
        let params = new HttpParams();
        if (page) {
            params = params.append("page", page);
        }
        if (pageSize) {
            params = params.append("pageSize", pageSize);
        }
        return this.http
        .get(`${this.REPORT_BASE_URL}/job/list-companyType`, {
            params,
        })
        .pipe(retry(2));
    };

    deleteJobById = (id) => this.http.delete(`${this.AUTH_BASE_URL}/job/deleteJob/${id}`).pipe(retry(2));
}
